import type { LayerProps } from 'react-map-gl/mapbox';
import type { Feature, FeatureCollection, GeoJsonProperties, Point } from 'geojson';
import type { DealCard } from '../../../../../utils/buildDealCards/dealCardTypes';

export const hotelDotsLayerStyle = (color: string): LayerProps => ({
  id: 'hotels',
  source: 'places',
  type: 'circle',
  paint: {
    'circle-radius': 4,
    'circle-stroke-color': 'white',
    'circle-stroke-width': 1,
    'circle-color': color,
  },
});

const getMarkersDotsGeoJSON = (dealCards: DealCard[]): FeatureCollection => {
  const markerPoints: Feature<Point, GeoJsonProperties>[] = dealCards
    .filter((dealCard) => dealCard.type !== 'dot')
    .map((dealCard) => {
      const {
        product: {
          accommodation: { longitude, latitude },
        },
      } = dealCard;
      return {
        type: 'Feature',
        properties: {
          icon: 'dot-pink-4',
        },
        geometry: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
      };
    });
  return {
    type: 'FeatureCollection',
    features: markerPoints,
  };
};

export default getMarkersDotsGeoJSON;
